'use client';

import { ModalProvider } from './ModalProvider';
import { ThemeProvider } from './ThemeProvider';
import CookieConsent from './CookieConsent';
import { TourProvider } from './TourProvider';

/** Providers globais do app (client). Montado na raiz para que qualquer página use useModal()/useTheme(). */
export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider>
      <TourProvider>
        <ModalProvider>
          {children}
          <CookieConsent />
        </ModalProvider>
      </TourProvider>
    </ThemeProvider>
  );
}
